import { RefObject } from 'react';
import { useAdvancedHover } from './useAdvancedHover';

export interface UseHoverOptions {
  // Time in milliseconds to wait before setting hover state to true
  enterDelay?: number;
  // Time in milliseconds to wait before setting hover state to false
  leaveDelay?: number;
}

export function useHover(target: RefObject<HTMLElement>, options: UseHoverOptions = {}): boolean {
  const [hovering] = useAdvancedHover(target, options);
  return hovering;
}
